// Label field that automatically saves the file label as you type
import React from "react";
import Cx from "classnames";

import styles from "./Editor.scss";

// encode data for sending via XHR
const xwwwfurlenc = (srcjson) => {
  if (typeof srcjson !== "object")
    if (typeof console !== "undefined") {
      console.log('"srcjson" is not a JSON object');
      return null;
    }
  const u = encodeURIComponent;
  let urljson = "";
  let keys = Object.keys(srcjson);
  for (let i = 0; i < keys.length; i++) {
    urljson += u(keys[i]) + "=" + u(srcjson[keys[i]]);
    if (i < keys.length - 1) urljson += "&";
  }
  return urljson;
};

export default class FileLabelEditor extends React.Component {
  state = {
    label: this.props.label,
  };

  onChange = (e) => {
    const filetype = this.props.filetype;
    const label = e.target.value;
    this.setState({ label });

    // throttle instant updates (wait 400ms)
    window.unsavedChanges(true);
    clearTimeout(window.editableChangeThrottleFileLabel);
    window.editableChangeThrottleFileLabel = setTimeout(() => {
      const tokenEl = document.querySelector(
        ".record > form > input[name=authenticity_token]"
      );
      const csrfToken = tokenEl ? tokenEl.value : "";

      const body = {
        utf8: "✓",
        _method: "put",
        [`${filetype}[label]`]: label,
      };

      fetch(`/${filetype}s/${this.props.id}`, {
        method: "POST",
        body: xwwwfurlenc(body),
        headers: {
          Accept: "application/json, text/javascript, */*; q=0.01",
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          "X-CSRF-Token": csrfToken,
          "X-Requested-With": "XMLHttpRequest",
        },
      })
        .then((res) => res.json())
        .then((response) => {
          window.unsavedChanges(false);
        });
    }, 400);
  };

  render() {
    const { label } = this.state;
    const { requireLabel } = this.props;

    return (
      <div>
        <input
          onChange={this.onChange}
          className={Cx(styles.input, { [styles.error]: (!label && requireLabel !== false) })}
          value={label}
          placeholder="Label"
          ref={(c) => {
            this.el = c;
          }}
        />
      </div>
    );
  }
}
